import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
// import { checkParams } from "../../../src/util/Util";
import "./WebLogin.css";
import { Context } from "../../context/Context";

const WebLogin = (props) => {
  const {clearAllData} = useContext(Context);
  localStorage.removeItem("userCompanyData");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passVisible, setPassVisible] = useState(false);
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  let navigate = useNavigate();

  
  useEffect(() => {
    clearAllData();
  }, [])

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
    localStorage.removeItem("isNew");
  }, [props]);

  useEffect(() => {
    window.onbeforeunload = null;
  }, []);

  const handleSignIn = (e) => {
    e.preventDefault();
    axios
      .post(window.ajaxLink + "user/login", {
        email: email.trim(),
        password: password,
        cloud: true,
      })
      .then((res) => {
        if (res.data.responseCode === 200) {
          localStorage.setItem("userData", JSON.stringify(res.data.responseData));
          props.checkLoggedIn(true);
          if (!res.data.responseData.is_otp_verified) {
            navigate("/verify");
          } else if (res.data.responseData.user_type === 2) {
            navigate("/dashboard");
          } else {
            navigate("/initial_questionare");
          }
        }
      })
      .catch((error) => {
        if (error.response.data.responseCode === 400) {
          setErrorEmail(error.response.data.errorData);
          // setErrorEmail("Invalid email address!");
        }
        if (error.response.data.responseCode === 401) {
          setErrorPassword("Invalid password!");
        }
      });
  };
  return (
    <div className="memberLoginBackground">
      <div className="memberLoginLeftSide">
        <div className="logo_img_header logo_light"></div>
        <div className="memberLeftTitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit</div>
        <div className="memberLoginBackground"></div>
      </div>
      <div className="memberRegisterContainer" style={{overflowY: 'auto', maxHeight: '100vh'}}>
        <form style={{paddingBottom: '5rem'}} className="memberRegisterHolder web_login_holder" action={(e) => handleSignIn(e)}>
          <div className="sign_title">Sign in to VirdioHealth</div>
          <div className="info_row_holder">
            <div className="form_title">Email Address</div>
            <div className="relative_holder">
              <input
                type="text"
                tabIndex="1"
                placeholder="john@email.com"
                className="gray_inputs gray_inputs_login"
                onChange={(e) => setEmail(e.currentTarget.value)}
              />
              {errorEmail && <div className="email_error_msg">{errorEmail}</div>}
            </div>
            <div className="form_title">Password</div>
            <div style={{marginTop: "0px"}} className="form_title form_forgot" onClick={() => navigate("/forgotpassword")}>
              Forgot password?
            </div>
            <div className="relative_holder">
              <input
                type={passVisible ? "text" : "password"}
                className="gray_inputs gray_inputs_login"
                onChange={(e) => setPassword(e.currentTarget.value)}
              />
              <div className="eye_show" onClick={() => setPassVisible(!passVisible)}>
                {passVisible && <div className="crossed_eye"></div>}
              </div>
            </div>
            <>{errorPassword && <div className="email_error_msg">{errorPassword}</div>}</>
          </div>
          <div className="bottomLoginPadding">
            <input type="submit" className="signNewButton signNew_login" value="Sign In" />
          </div>
          <div className="bottomLoginPadding">
            <div>
              Don't have an account?
              <Link to={"/register"}> Sign up</Link>
            </div>
          </div>
          {/*<div className="borderMainHolder">
          <div className="bottomBorderPart"></div>
          <div className="orTextPart">OR</div>
          <div className="bottomBorderPart"></div>
        </div>
        <div className="otherLoginHolder">
          <div className="fbButtonPart" id="openFb">
            <div className="fbLogoImg"></div>
            <div className="fbText">Continue with Facebook</div>
          </div>
          <div className="fbButtonPart appleBtnPadding">
						<div    
							id="appleid-signin" 
							className="signin-button" 
							data-color="white"     
							data-border="false" 
							data-type="sign-in"
							data-mode="center-align"
							data-width="100%"
						></div>
					</div>
          
						<div className="fbButtonPart">
							<div className="fbLogoImg googleLogo"></div>
							<div className="fbText">Continue with Google</div>
						</div>
					
        </div> */}
        </form>
      </div>
    </div>
  );
};

export default WebLogin;
